.wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: var(--matisse);
    gap: 2.5rem;
    padding: 1.5rem 0;
    flex-wrap: wrap;
}

.button {
    align-items: center;
    background-color: transparent;
    border: 2px solid var(--white);
    border-radius: 3rem;
    box-shadow: 0 3px 6px rgb(var(--alto-base) / 33%);
    color: var(--white);
    display: flex;
    font-size: 0.875rem;
    justify-content: center;
    gap: 1rem;
    min-height: 3.75rem;
    min-width: 215px;
    padding: 0.5rem 1.5rem;
    text-decoration: none;
    text-transform: uppercase;
}

.applyButton {
    composes: button;
    background: linear-gradient(to right, transparent, var(--tropez));

    &:hover {
        background: linear-gradient(to left, transparent, var(--tropez));
    }
}

.icon {
    fill: var(--white);
    height: 30px;
    width: 30px;
}
